import React, { useState } from "react";
import { Box, Paper, TextField } from "@mui/material";
import classes from "pages/Auth/login.module.css";
import Logo from "components/Logo";
import Footer from "components/Content/Footer/Footer";

import { Button } from "@mui/material";

import { RequestAuthorizationCode } from "react-oauth2-auth-code-flow";
import { oauthClient, scopes } from "Auth";

import ComputerOutlinedIcon from '@mui/icons-material/ComputerOutlined';
import CloudSyncOutlinedIcon from '@mui/icons-material/CloudSyncOutlined';

export default function Login() {
    const [isLoginButtonDisabled, setIsLoginButtonDisabled] = useState(false);

    return (
        <div style={{ width: "100%" }}>
            <div className={classes.login}>
                <Logo />

                <RequestAuthorizationCode
                    oauthClient={oauthClient}
                    render={({ url }) => (
                        <Button
                            variant="outlined"
                            size="large"
                            onClick={() => {
                                setIsLoginButtonDisabled(true);
                                window.location.href = `${url}&scope=${scopes.join(" ")}`
                            }}
                            disabled={isLoginButtonDisabled}
                        >
                            Connect to Align Admin
                        </Button>
                    )}
                />
            </div>
            
            <Box display="flex" justifyContent="center">
                <Paper elevation={3} sx={{ padding: "15px", marginBottom: "55px", width: "900px" }}>
                    <Box component="h3" color="secondary.main" textAlign="center">
                        Security Data Protection
                    </Box>
                    <Box textAlign="center">
                        <ComputerOutlinedIcon fontSize="large" color="primary" className="me-3" />
                        Align Admin employs industry best practices when storing client data at rest.
                    </Box>
                    <Box textAlign="center">
                        <CloudSyncOutlinedIcon fontSize="large" color="primary" className="me-3" />
                        Align Admin utilizes advanced encryption standards to maximize the security of our data in transit.
                    </Box>
                </Paper>
            </Box>

            <Footer />
        </div>
    );
}
